import { render, staticRenderFns } from "./onlineStudyDetails.vue?vue&type=template&id=dc7f5786&scoped=true&"
import script from "./onlineStudyDetails.vue?vue&type=script&lang=js&"
export * from "./onlineStudyDetails.vue?vue&type=script&lang=js&"
import style0 from "./onlineStudyDetails.vue?vue&type=style&index=0&id=dc7f5786&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7f5786",
  null
  
)

export default component.exports